// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../../../shared/components/labeled-string';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildDate} from '../../../../../shared/services/build-date';

const PurchaseInformation = (props, context) =>
    <section className='purchase-information'>
        <header>
            <FormattedMessage id='PURCHASE_INFO'/>
        </header>
        <div>
            <LabeledString
                data={props.product.invoicedDealer.name}
                label='RETAILER_NAME'
            />
            <LabeledString
                data={buildDate(props.product.deliveryDate, context.user.settings.general.dateFormat.key)}
                label='DELIVERED'
            />
        </div>
    </section>;

PurchaseInformation.displayName = 'PurchaseInformation';
PurchaseInformation.propTypes = {
    product: PropTypes.instanceOf(Product).isRequired
};
PurchaseInformation.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default PurchaseInformation;



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/components/purchase-information/index.js